"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vue = _interopRequireDefault(require("vue"));

var _vuePropertyDecorator = require("vue-property-decorator");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CountdownComponent = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(CountdownComponent, _Vue);

  var _super = _createSuper(CountdownComponent);

  function CountdownComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, CountdownComponent);
    _this = _super.apply(this, arguments);
    _this.interval = null;
    _this.refreshTime = 3600;
    return _this;
  }

  (0, _createClass2.default)(CountdownComponent, [{
    key: "onRefreshTimeChanges",
    value: function onRefreshTimeChanges(newVal) {
      if (this.isAutoRefresh && newVal === 0) {
        this.resetTimer();
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.refreshTime = this.defaultRefreshTime;
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "startTimer",
    value: function startTimer() {
      var _this2 = this;

      if (this.interval) {
        clearInterval(this.interval);
      }

      this.interval = setInterval(function () {
        _this2.refreshTime--;

        if (_this2.refreshTime <= 0) {
          clearInterval(_this2.interval);

          _this2.$emit('onCountdownZero');
        }
      }, 1000);
    }
  }, {
    key: "resetTimer",
    value: function resetTimer() {
      this.refreshTime = this.defaultRefreshTime;
      this.startTimer();
    }
  }]);
  return CountdownComponent;
}(_vue.default);

(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 30
})], CountdownComponent.prototype, "defaultRefreshTime", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: true
})], CountdownComponent.prototype, "isAutoRefresh", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('refreshTime')], CountdownComponent.prototype, "onRefreshTimeChanges", null);
CountdownComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'CountdownComponent'
})], CountdownComponent);
var _default = CountdownComponent;
exports.default = _default;